import { render, staticRenderFns } from "./TenantGuidelinesDetailStandards.vue?vue&type=template&id=7a99834b"
import script from "./TenantGuidelinesDetailStandards.vue?vue&type=script&lang=js"
export * from "./TenantGuidelinesDetailStandards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports